import { createContext } from 'react';

import type { UserDto } from '../api/types';

type AuthContextType = {
  user: UserDto;
};

export const AuthContext = createContext({} as AuthContextType);
